

$(document).ready(function() {
    fillCountries();

    $('.notTCCheck').change(function() {
        var tcnoid = $(this).attr("tcnoid");
        var passnoid=$(this).attr("passnoid");
        var passportCountryId=$(this).attr("passportCountry");
        var needPassportNo=$(this).hasClass("needPassport");

        if($(this).is(":checked")) {
            $('#'+tcnoid).attr("disabled", "disabled");
            $('#'+tcnoid).addClass("ignore");
            $('label[for="'+tcnoid+'"]').hide();

            if(!needPassportNo) {
                $('#'+passnoid).removeAttr("disabled", "disabled");
                $('#'+passnoid).removeClass("ignore");

                if ($('#'+passportCountryId).data('dd')){
                    $('#'+passportCountryId).data('dd').set('disabled', false);
                }
            }
        } else {
            $('#'+tcnoid).removeAttr("disabled", "disabled");
            $('#'+tcnoid).removeClass("ignore");


            if(!needPassportNo) {
                $('#'+passnoid).attr("disabled", "disabled");
                $('#'+passnoid).addClass("ignore");
                $('label[for="'+passnoid+'"]').hide();

                if ($('#'+passportCountryId).data('dd')){
                    $('#'+passportCountryId).data('dd').set('disabled', true);
                }
            }
        }
    });
	
	$( '.titleTip' ).tipTip();
	
	var route = $(".route");
	for (var i = 0; i < route.length; i++) {
		route[i].innerHTML = route[i].innerHTML.toLowerCase();
	}		
});

$("#makeTicketFinal").click(function() {

	var isvalid = $("#reservationForm").valid() && emailValidation();
	if (!isvalid)
		return false;
	
	if(!checkAgreementStatus()){
		alert(FmtMessage.getMessage('js.payment.agreement.warning'));
		return false;
	}

	$("#payDetailCC").hide();
	openLoaderBox();
	clearMasterpassCCInfoAndPaymentForm();
	var guid = $('#guid').val();
	saveReservationAjax("/bus/saveReservationRequest?isAccount="+false,'#reservationForm','/bus/ccform/process?guid=' + guid);
	
});


$("#makeTicketMasterpassFinal").click(function() {

    var isvalid = $("#reservationForm").valid() && emailValidation();
    if (!isvalid)
        return false;

    if(!checkAgreementStatus()){
        alert(FmtMessage.getMessage('js.payment.agreement.warning'));
        return false;
    }

    $("#payDetailMasterpass").hide();
    openLoaderBox();
    clearCCInfo();

    var guid = $('#guid').val();
    saveReservationAjax("/bus/saveReservationRequest?isAccount="+false,'#reservationForm','/bus/ccform/process?guid=' + guid);

});

$("#makeTicketBkmFinal").click(function() {

    var isvalid = $("#reservationForm").valid() && emailValidation();
    if (!isvalid)
        return false;

    if(!checkAgreementStatus()){
        alert(FmtMessage.getMessage('js.payment.agreement.warning'));
        return false;
    }

    $(".payDetailButtons").hide();
    openLoaderBox();
    clearCCInfo();

    var guid = $('#guid').val();
    saveReservationAjax("/bus/saveReservationRequest?isAccount="+false+"&isBkm="+true,'#reservationForm','/bus/ccform/process?guid=' + guid);

});

$("#makeTicketAccountFinal").click(function() {
	var isvalid = $("#reservationForm").valid() && emailValidation();
	if (!isvalid)
		return false;
	
	if(!checkAgreementStatus()){
		alert(FmtMessage.getMessage('js.payment.agreement.warning'));
		return false;
	}
	
	$("#accountpaymentprocess").show();
	
	openLoaderBox();
	
	var guid = $('#guid').val();
	saveReservationAjax("/bus/saveReservationRequest?isAccount="+true,'#reservationForm','/bus/ccform/process?guid=' + guid);
	
});


function paymentOK(msg, reservationId) {

	if(!CommonPayment.use3DSecure){
		closeLoaderBox();
		try {
			$('[name=3dsecureFrameVpos]').attr('src', 'about:blank');
			$("[name=3dsecureFrameVpos]").contents().find("head").html('');
			$("[name=3dsecureFrameVpos]").contents().find("body").html('');
		} catch (e) {
		}
	} else {
		$('#bankprocess').hide();
		
		 var modalDiv = $("#3dsecureDiv");
		 modalDiv.dialog("close");
		 try {
			$('[name=3dsecureFrame]').attr('src', 'about:blank');
			$("[name=3dsecureFrame]").contents().find("head").html('');
			$("[name=3dsecureFrame]").contents().find("body").html('');
		 } catch (e) {
		 }
	}

    $('#ccDiv').hide();
    $("#payDetailCC").hide();
    $('#taksit,#bankSelection').hide();
    
	 $('#bankprocessfail').html(msg);
	 $('#bankprocessfail').removeClass('cc-error');
	 $('#bankprocessfail').addClass('alert-success');
	 $('#bankprocessfail').show();
	 
	markSaleConversion();
	
	
	$('#ticketSuccessForm').find('#reservationId').val(reservationId);
	$('#ticketSuccessForm').submit();
}
